import React from 'react';
import WorkspacePage from '../components/layout/WorkspacePage';
import './SetupWizard.css';

function DashboardPreview({ onboardingStatus, onNavigate, user }) {
  const counts = onboardingStatus?.counts || {};
  const launchReady = Boolean(onboardingStatus?.isComplete || (
    counts.locations > 0
    && counts.managers > 0
    && counts.users > 0
    && counts.kpis > 0
    && counts.goals > 0
  ));

  // Sprint 3B.8: DashboardPreview demonstrates a 4-card KPI board +
  // a CTA lane. The page LITERALLY previews a dashboard (the layout
  // is the message), so width="operational" is the right fit per the
  // sprint guidance ("operational only if the page contains
  // dashboard/table-like operational content"). The inline
  // .preview-header block is removed — its eyebrow / title /
  // subtitle / "Setup Wizard" CTA flow into WorkspacePage's standard
  // slots. The inner <section className="dashboard-preview"> with
  // aria-labelledby="dashboard-preview-title" survives so the
  // existing .preview-board / .preview-lane layouts keep applying.
  const setupAction = (
    <button type="button" onClick={() => onNavigate('/setup')}>
      <i className="fas fa-list-check"></i>
      Setup Wizard
    </button>
  );

  return (
    <WorkspacePage
      data-workspace-id="dashboard-preview"
      width="operational"
      eyebrow="Dashboard Preview"
      title={`${user?.companyName || 'Company'} Executive Snapshot`}
      subtitle="Preview the private workspace feel before the full command center opens."
      actions={setupAction}
    >
      <section className="dashboard-preview" aria-labelledby="dashboard-preview-title">
      <div className="preview-board">
        <div className="preview-kpi-card primary">
          <span>Your workspace</span>
          <strong>{user?.companyName || 'Private Company'}</strong>
          <small>Current scope is isolated to this authenticated company.</small>
        </div>
        <div className="preview-kpi-card">
          <span>Locations Ready</span>
          <strong>{counts.locations || 0}</strong>
          <small>Operational sites in the starter workspace.</small>
        </div>
        <div className="preview-kpi-card">
          <span>Team Ready</span>
          <strong>{counts.managers || 0}</strong>
          <small>Leaders and team members available for dashboards.</small>
        </div>
        <div className="preview-kpi-card">
          <span>Goals Ready</span>
          <strong>{counts.goals || 0}</strong>
          <small>Initial targets available for reporting.</small>
        </div>
      </div>

      <div className="preview-lane">
        <div>
          <h3>Simple first, powerful later</h3>
          <p>Starter Mode keeps the first ten minutes focused on setup, locations, team, and a preview. Advanced governance and audit workflows remain hidden until launch.</p>
        </div>
        <button type="button" onClick={() => onNavigate(launchReady ? '/executive' : '/setup')}>
          <i className={`fas ${launchReady ? 'fa-chart-line' : 'fa-arrow-left'}`}></i>
          {launchReady ? 'Open Snapshot' : 'Finish Setup'}
        </button>
      </div>
      </section>
    </WorkspacePage>
  );
}

export default DashboardPreview;
